import crypter from "crypto-js";


export function Encrypt(data:any) {
    const ciphertext = crypter.AES.encrypt(data, 'BlaBlaBlackSheepHomneyanywool').toString();

    return ciphertext
}

export function Decrypt(data:any) {
    //console.log(data)
    if(data==undefined||null)
    {
        console.log('error')
        return
    }
    const bytes  = crypter.AES.decrypt(data, 'BlaBlaBlackSheepHomneyanywool');
   // console.log(bytes)
    const originalText = bytes.toString(crypter.enc.Utf8);
    //console.log(originalText)

    return originalText
}


